import { render } from "./BandOpportunity.vue?vue&type=template&id=12c4a35d&scoped=true"
import script from "./BandOpportunity.vue?vue&type=script&lang=js"
export * from "./BandOpportunity.vue?vue&type=script&lang=js"

import "./BandOpportunity.vue?vue&type=style&index=0&id=12c4a35d&scoped=true&lang=css"

import exportComponent from "E:\\新建文件夹\\简策demo\\V策财经\\V策财经web-push\\vce-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12c4a35d"]])

export default __exports__